import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

AppStoreTagsData.propTypes = {
  tag: PropTypes.string,
  component: PropTypes.elementType,
};

function AppStoreTagsData(props) {
  const list = useSelector((state) => {
    // console.log("AppStoreTagsData:selector",  state.Content.activity?.store?.tags?.[props.tag]);
    return state.Content.activity?.["app-store"]?.tags?.[props.tag];
  });
  // console.log("AppStoreTagsData:render",  list);
  return React.createElement(props.component, {list, ...props});
}

export default AppStoreTagsData;
